import Decimal from "decimal.js";

export function toDecimal(value: number | string | Decimal): Decimal {
  return new Decimal(value);
}

export function sumOf(array: (number|string|Decimal)[]) : Decimal {
  return array.reduce((accumulator, currentValue) => {
    return new Decimal(accumulator).add(new Decimal(currentValue));
  }, new Decimal(0)) as Decimal;
}

export function sumBy(array: [], key: string) : Decimal {
  return array.reduce((accumulator, currentValue) => {
    return new Decimal(accumulator).add(new Decimal(currentValue[key]));
  }, new Decimal(0));
}
